var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconatuadores(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.142,
    height: 37.147,
    viewBox: "0 0 37.142 37.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_atuadores",
    "data-name": "icon atuadores",
    transform: "translate(23229 14899.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_22904",
    "data-name": "Ret\\xE2ngulo 22904",
    transform: "translate(-23229 -14881.562)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.142,
    height: 19.69,
    rx: 9.845,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 35.642,
    height: 18.19,
    rx: 9.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_499",
    "data-name": "Elipse 499",
    transform: "translate(-23225.314 -14877.877)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.16,
    cy: 6.16,
    r: 6.16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.16,
    cy: 6.16,
    r: 5.41,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-wifi-1510573",
    transform: "translate(-23221.551 -14898.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32502",
    "data-name": "Caminho 32502",
    d: "M162.33,157.7a15.542,15.542,0,0,0-11.027,4.567h0a.313.313,0,1,0,.443.443,14.959,14.959,0,0,1,21.167,0,.313.313,0,1,0,.443-.443A15.539,15.539,0,0,0,162.33,157.7Z",
    transform: "translate(-151.208 -157.7)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32503",
    "data-name": "Caminho 32503",
    d: "M201.963,217.07a12.23,12.23,0,0,0-8.678,3.594.313.313,0,1,0,.443.443,11.636,11.636,0,0,1,16.469,0h0a.313.313,0,1,0,.443-.443,12.23,12.23,0,0,0-8.678-3.594Z",
    transform: "translate(-190.842 -213.749)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32504",
    "data-name": "Caminho 32504",
    d: "M241.582,276.46a8.926,8.926,0,0,0-6.328,2.617.313.313,0,1,0,.443.443,8.324,8.324,0,0,1,11.771,0,.313.313,0,1,0,.443-.443,8.926,8.926,0,0,0-6.328-2.617Z",
    transform: "translate(-230.461 -269.816)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32505",
    "data-name": "Caminho 32505",
    d: "M281.239,335.83a5.615,5.615,0,0,0-3.979,1.645.313.313,0,1,0,.443.443,5,5,0,0,1,7.074,0,.313.313,0,1,0,.442-.443,5.614,5.614,0,0,0-3.979-1.645Z",
    transform: "translate(-270.117 -325.865)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconatuadores);
export default __webpack_public_path__ + "static/media/icon atuadores.8768e2f863aa089eadc5a99dee31bc75.svg";
export { ForwardRef as ReactComponent };